import { handleRecordClick } from "../../util/vmTrackingHandler";

export function gtmPageView(gtmEventName) {
    const dataLayer = window ? window.dataLayer : null;

    if (dataLayer) {
        dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: `/virtual/${gtmEventName}`,
            virtualPageTitle: gtmEventName,
        });
    }
}

export function gtmAlert(gtmEventName) {
    const dataLayer = window ? window.dataLayer : null;

    if (dataLayer) {
        dataLayer.push({
            event: gtmEventName,
        });
    }
}

export function gtmCustomEvent(category, action, label) {
    const dataLayer = window ? window.dataLayer : null;
    if (dataLayer) {
        dataLayer.push({
            event: 'customEventTrigger',
            customEventCategory: category,
            customEventAction: action,
            customEventLabel: label,
        });
    }

    let url = '';

    if (window && window.location && window.location.pathname) {
        url = window.location.pathname;
    }
    handleRecordClick(category, action, label, label, url);
}

export function newGtmCustomEvent(customEvent) {
    const dataLayer = window ? window.dataLayer : null;
    if (dataLayer) {    
        let dataLayerObj = {};

        if (customEvent && customEvent.event_name) {
            dataLayerObj['ga4_event_name'] = customEvent.event_name;
        }
        if (customEvent && customEvent.btn_label) {
            dataLayerObj['ga4_btn_label'] = customEvent.btn_label;
        }
        if (customEvent && customEvent.feature_name) {
            dataLayerObj['ga4_feature_name'] = customEvent.feature_name;
        }
        if (customEvent && customEvent.segment_name) {
            dataLayerObj['ga4_segment_name'] = customEvent.segment_name;
        }
        if (customEvent && customEvent.action_name) {
            dataLayerObj['ga4_action_name'] = customEvent.action_name;
        }
        if (customEvent && customEvent.btn_value) {
            dataLayerObj['ga4_btn_value'] = customEvent.btn_value;
        }

        dataLayer.push({
            event: 'ga4CustomEvent',
            ...dataLayerObj
        });
    }
}
